import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=a34819ce&scoped=true&"
import script from "./Teacher.vue?vue&type=script&lang=js&"
export * from "./Teacher.vue?vue&type=script&lang=js&"
import style0 from "./Teacher.vue?vue&type=style&index=0&id=a34819ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34819ce",
  null
  
)

export default component.exports